"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementSection = void 0;
var react_1 = __importDefault(require("react"));
var UseAnalyticsAccountSettings_1 = require("./UseAnalyticsAccountSettings");
var SectionHeading_1 = require("./SectionHeading");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var UseSaveableState_1 = require("Utils/UseSaveableState");
var c = (0, BemBuilder_1.default)("analytics-and-reports-settings");
var EngagementSection = function () {
    var _a = (0, UseAnalyticsAccountSettings_1.useAnalyticsAccountSettings)(), data = _a.data, updateEngagement = _a.updateEngagement;
    var _b = __read((0, UseSaveableState_1.useSaveableState)(data === null || data === void 0 ? void 0 : data.engagement, updateEngagement), 4), localState = _b[0], setUnsavedState = _b[1], save = _b[2], _c = _b[3], disableInputs = _c.disableInputs, disableSave = _c.disableSave;
    return (react_1.default.createElement("div", { className: c("section") },
        react_1.default.createElement(SectionHeading_1.SectionHeading, { icon: react_1.default.createElement(icons_1.Engagement, null), headingText: "Engagement", description: react_1.default.createElement(kaleidoscope_1.Text, null, "Manage how engagement algorithms can be set on pages") }),
        react_1.default.createElement(kaleidoscope_1.Card, null,
            react_1.default.createElement(kaleidoscope_1.Stack, { padding: "m", align: "center", justify: "center" },
                react_1.default.createElement("div", { style: { width: "450px" } },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Allow creators to set engagement algorithms on pages", value: localState ? localState.allowCreatorsToAssignPages : false, disabled: disableInputs, onChange: function (isActive) { return setUnsavedState(__assign(__assign({}, localState), { allowCreatorsToAssignPages: isActive })); } })))),
        react_1.default.createElement(kaleidoscope_1.Button, { className: c("update-button"), size: kaleidoscope_1.ButtonSize.Large, onClick: save, disabled: disableSave }, "Update engagement permissions")));
};
exports.EngagementSection = EngagementSection;
